let rui = {
    rAccordions: [],
    rTabs: []
};
